import { useState, useEffect } from 'react';
import tw from 'tailwind-styled-components';
import { capitalizeFirstLetter } from "../helpers";
import { useRef } from "react";

const statusLabels = {
    1: "PENDING",
    2: "REQUESTED",
    3: "OCCUPIED",
    4: "MOVING_OUT",
    5: "RESERVED"
};

const statusColors = {
    1: "bg-gray-100 text-gray-500",
    2: "bg-red-100 text-red-500",
    3: "bg-green-100 text-green-500",
    4: "bg-orange-100 text-orange-500",
    5: "bg-purple-100 text-purple-500",
    6: "bg-yellow-100 text-yellow-500",
    7: "bg-purple-100 text-purple-500",
};
const getStatusLabel = (status) => statusLabels[status] || "INACTIVE";
const getStatusColor = (status) => statusColors[status] || "bg-gray-200 text-gray-600";
const TopSearchDropdown = ({ options, name, onChange, anchorRef, setShowDropdown }) => {

    const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
    const dropdownRef = useRef(null);
    useEffect(() => {
        if (anchorRef?.current) {
            const rect = anchorRef.current.getBoundingClientRect();

            setPosition({
                top: rect.bottom + 8,
                left: rect.left,
                width: rect.width,
            });
        }
    }, [anchorRef, options]);

    useEffect(() => {
        const handleClick = (e) => {
            if (
                !dropdownRef.current?.contains(e.target) &&
                !anchorRef.current?.contains(e.target)
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const [isOpen, setIsOpen] = useState(true);
    const [selectedOption, setSelectedOption] = useState([]);
    const [closeTimeout, setCloseTimeout] = useState(null);

    useEffect(() => {
        setIsOpen(true);
    }, [options]);

    const handleOptionSelect = (option) => {
        onChange(option);
        setSelectedOption(option);
        setIsOpen(false);
    };

    useEffect(() => {
        return () => {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }
        };
    }, [closeTimeout]);

    return (
        <div
            ref={dropdownRef}
            style={{
                position: "fixed",
                top: position.top,
                left: position.left,
                width: position.width,
                zIndex: 9999,
            }}
        >
            <div>
                <DropdownContainer >
                    {isOpen && (
                        <DropdownMenu>

                            {options.length > 0 ? (
                                options.map((option) => (
                                    <Card
                                        key={option?.occupancyId}
                                        onClick={() => handleOptionSelect(option)}
                                    >
                                        <div className="flex flex-col">
                                            <Name>{capitalizeFirstLetter(option?.name)}</Name>
                                            <Details>
                                                #{option.roomNum}, {option.flatName}, {option.propName}
                                            </Details>
                                        </div>

                                        <Status $status={option?.status}>
                                            {option.type === 'moveOut'
                                                ? 'Inactive'
                                                : getStatusLabel(option.status)}
                                        </Status>
                                    </Card>
                                ))
                            ) : (
                                <div className="px-4 py-6 text-sm text-gray-500 text-center">
                                    No results found
                                </div>
                            )}

                        </DropdownMenu>
                    )}
                </DropdownContainer>
            </div>
        </div>
    );
};

//const DropdownContainer = tw.div`relative rounded-sm custom-scrollbar w-[410px]`;
//const DropdownMenu = tw.div`absolute top-full left-0 bg-white  rounded-b-lg shadow-lg z-10 transition-opacity duration-300 ease-in-out mt-3 overflow-y-scroll max-h-60 w-[410px]`;
//const Card = tw.div`p-3 hover:bg-slate-50 transition cursor-pointer border-b border-gray-200 last:border-b-0 w-[400px]`;
//const Header = tw.div`flex justify-between items-start mb-1`
//const Name = tw.div`text-gray-800 text-md`;
//const Details = tw.div`flex items-center justify-between text-sm text-gray-600`
const Item = tw.div`flex items-center gap-1`
//const Role = tw.div`text-sm text-primary-color`;
//const Status = tw.div`text-[10px] px-2.5 w-auto h-6 flex items-center justify-center rounded-full  ${({ $status }) => getStatusColor($status)}`;

const DropdownContainer = tw.div`relative w-full`;

const DropdownMenu = tw.div`
  left-0 mt-2 w-full
  bg-white border border-gray-200
  rounded-lg shadow-lg
  overflow-hidden z-[9999]
  max-h-64 overflow-y-auto

  /* Tailwind scrollbar */
  scrollbar-thin scrollbar-thumb-gray-300 hover:scrollbar-thumb-gray-400

  /* Custom scrollbar (important) */
  [&::-webkit-scrollbar]:w-1.5
  [&::-webkit-scrollbar-track]:bg-transparent
  [&::-webkit-scrollbar-thumb]:bg-gray-300
  [&::-webkit-scrollbar-thumb]:rounded-full
`;

const Card = tw.div`
  px-4 py-3
  flex items-center justify-between
  hover:bg-gray-50
  transition cursor-pointer
`;

const Header = tw.div`flex flex-col`;

const Name = tw.div`text-sm font-medium text-gray-800`;

const Details = tw.div`text-xs text-gray-500`;

const Role = tw.div``;

const Status = tw.div`
  text-[10px]
  px-2 py-1
  rounded-full
  font-medium
  ${({ $status }) => getStatusColor($status)}
`;
export default TopSearchDropdown;